import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { Error } from 'src/app/utils/common-classes';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/services/Utils/utils.service';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public form: FormGroup;
  public loginError: string;
  public formSubmitAttempt: boolean;
  private returnUrl: string;
  public lang: string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    public utils: UtilsService,
    private translate: TranslateService
  ) {
    let _self = this;
    _self.lang = _self.utils.getLanguage();
    _self.translate.use(_self.lang);
  }

  async ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home';
    this.form = this.fb.group({
      username: ['', Validators.email],
      password: ['', Validators.required]
    });

    if (this.authService.getToken()) {
      await this.router.navigate([this.returnUrl]);
    }
  }

  async onSubmit() {
    let _self = this;
    _self.loginError = "";
    _self.formSubmitAttempt = false;
    if (_self.form.valid) {
      const username = _self.form.get('username').value;
      const password = _self.form.get('password').value;
      _self.authService.login(username, password).then(() => {
        _self.loginError = "";
        _self.router.navigate(['home']);
      }).catch((err) => {
        return _self.utils.getError(err);
      }).then((translatedError) => {
        if (translatedError) {
          _self.loginError = translatedError;
        }
      }).finally(() => {
        _self.utils.hideShortLoader();
      });
    } else {
      _self.formSubmitAttempt = true;
    }
  }

  public changeLanguage(event: MatSelectChange): void {
    this.utils.setLanguage(this.lang);
  }
}